import React from "react";
import i18next from 'i18next';
import {viLanguage} from './vi/viLanguage';
import {enLanguage} from './en/enLanguage';
import {laosLanguage} from './laos/laosLanguage';

const withTranslation = BaseComponent => (props) => {
    let language = "vi";
    if (localStorage.getItem("language")) {
        language = localStorage.getItem("language");
    }

    const viTranslation = {...viLanguage};
    const enTranslation = {...enLanguage};
    const laosTranslation = {...laosLanguage};

    i18next.init({
        lng: language,
        debug: false,
        resources: {
            vi: {translation: viTranslation},
            en: {translation: enTranslation},
            laos: {translation: laosTranslation},
        }
    });

    return (
        <React.Fragment>
            <BaseComponent {...props}/>
        </React.Fragment>
    );
};

export default withTranslation;
